<template>
  <v-form ref="form" autocomplete="off">
    <div class="d-flex align-center ga-4 mb-4">
      <h2 class="font-weight-bold">Linea {{ this.Linea }} - {{ this.descLinea }}</h2>
      <v-divider class="mx-4" inset vertical></v-divider>
    </div>
    <!-- ================= FORMULARIO ================= -->
    <v-row>
      <v-col cols="12" md="10">
        <v-autocomplete
          v-model="editedItem.ProcesoAsignado"
          :items="ArrayProcesos"
          :item-title="
            (ArrayProcesos) =>
              ArrayProcesos.ProcesoId + '-' + ArrayProcesos.Descripcion
          "
          item-value="ProcesoId"
          color="primary"
          label="Proceso a relacionar:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="blue" @click="adicionarProceso"> Adicionar </v-btn>
      </v-col>
    </v-row>

    <div align="right" class="mb-6">
      <v-btn color="green" @click="ValidateCampos"> Guardar </v-btn>
    </div>

    <!-- ================= TABLA DRAG ================= -->

    <v-card>
      <v-card>
        <v-card-title> Ordenar Líneas - Procesos</v-card-title>

        <v-table height="550px">
          <thead>
            <tr>
              <th style="width: 40px"></th>
              <th style="width: 40px">Orden</th>
              <th>Sigla</th>
              <th>Descripción</th>
            </tr>
          </thead>

          <draggable
            v-model="items"
            tag="tbody"
            item-key="Proceso"
            handle=".drag-handle"
            animation="200"
            @end="guardarOrden"
          >
            <template #item="{ element }">
              <tr>
                <td class="drag-handle">☰</td>
                <td>{{ element.OrdenProceso }}</td>
                <td>{{ element.Sigla }}</td>
                <td>{{ element.Proceso }} - {{ element.DescProceso }}</td>
              </tr>
            </template>
          </draggable>
        </v-table>
      </v-card>
    </v-card>
  </v-form>

  <!-- ================= PROGRESO ================= -->

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  upsertLineaCreditoProceso,
  getRelacionLineaCreditoProceso,
} from "@/views/TCI/ProcesosP/RelacionLineaCreditoProceso/RelacionLineaCreditoProcesoService";
import { getAllProcess } from "@/views/TCI/ProcesosP/Procesos/ProcesosService";

export default {
  name: "relacion-proceso-linea",

  components: {
    draggable,
  },

  data() {
    return {
      progreso: false,
      linea: null,
      descLinea: null,
      editedItem: {
        ProcesoAsignado: null,
      },

      modelfiltro: [
        {
          campo: "LineaCredito",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Linea:",
        },
      ],
      ArrayProcesos: [],
      items: [],
    };
  },

  methods: {
    async ValidateCampos() {
      if (this.items.length === 0) {
        this.$swal({
          icon: "warning",
          title: "No hay procesos para guardar",
        });
        return;
      }

      this.progreso = true;

      try {
        const modificados = this.items.filter(
          (item) => !item.EsNuevo && item.OrdenOriginal !== item.OrdenProceso,
        );

        const nuevos = this.items.filter((item) => item.EsNuevo);

        const payload = [...modificados, ...nuevos];

        await upsertLineaCreditoProceso(payload);

        this.$swal({
          icon: "success",
          title: "Guardado correctamente",
        });

        this.getConsultData();
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.items = [];
      this.progreso = true;
      this.modelfiltro[0].contenido = this.linea.toString();
      this.modelfiltro[0].filtro = "=";
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: true,
      };
      try {
        const result = await getRelacionLineaCreditoProceso(data);

        // 🔥 Guardamos el orden original
        this.items = result.map((item) => ({
          ...item,
          OrdenOriginal: item.OrdenProceso,
          EsNuevo: false, // bandera para nuevos
        }));
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
        this.dialogframe = false;
      }
    },

    guardarOrden() {
      this.items.forEach((item, index) => {
        item.OrdenProceso = index + 1;
      });

      console.log("Nuevo orden:", this.items);
    },

    async adicionarProceso() {
      if (!this.editedItem.ProcesoAsignado) {
        this.$swal({
          icon: "warning",
          title: "Seleccione un proceso",
        });
        this.$refs.form.validate();
        return;
      }

      // Buscar el proceso completo en el array
      const procesoSeleccionado = this.ArrayProcesos.find(
        (p) => p.ProcesoId === this.editedItem.ProcesoAsignado,
      );

      if (!procesoSeleccionado) return;

      // Evitar duplicados
      const existe = this.items.some(
        (item) => item.Proceso === procesoSeleccionado.ProcesoId,
      );

      if (existe) {
        this.$swal({
          icon: "warning",
          title: "El proceso ya fue agregado",
        });
        return;
      }

      var userperfil = this.$store.getters.userperfil;
      // Agregar a la tabla
      this.items.push({
        LineaCredito: this.linea,
        Sigla: procesoSeleccionado.Sigla,
        Proceso: procesoSeleccionado.ProcesoId,
        DescProceso: procesoSeleccionado.Descripcion,
        OrdenProceso: this.items.length + 1,
        UsuarioCreacion: userperfil.userInfo.Usuario_ID,
        UsuarioActualizacion: userperfil.userInfo.Usuario_ID,
        OrdenOriginal: null, // no tiene orden original
        EsNuevo: true, // es nuevo
      });

      // Limpiar selección
      this.editedItem.ProcesoAsignado = null;
    },

    // Consulta Procesos
    async getProcesos() {
      this.ArrayProcesos = [];
      const result = await getAllProcess();
      this.ArrayProcesos = result;
    },
  },

  mounted() {
    if (this.$route.query) {
      this.linea = this.$route.query.linea;
      this.descLinea = this.$route.query.descLinea;
    }
    this.getConsultData();
    this.getProcesos();
  },
};
</script>

<style>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
</style>
